import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Project, ProjectState } from 'utils/interface.utils';

const initialState: ProjectState = {
  currentProject: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProject: (state, action: PayloadAction<Project>) => {
      state.currentProject = action.payload;
    },
    clearProject: (state) => {
      state.currentProject = null;
    },
  },
});

export const { setProject, clearProject } = projectSlice.actions;
export default projectSlice.reducer;
